// src/api/preneed-profile.api.ts
import customAxios from "../index";
import qs from "qs";

export const getPaymentBillingList = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/planner-dashboard/payment-billing",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getPaymentBillingDetails = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/planner-dashboard/payment-billing/details/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};


export const downloadInvoice = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/planner-dashboard/payment-billing/download-invoice/${id}`,
    responseType: "blob",
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const shareInvoice = (id: string, data: { timezone: string; emails: string[] }) => {
  return customAxios({
    method: "POST",
    data,
    url: `/planner-dashboard/payment-billing/share-invoice/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const createService = (data: any) => {
  return customAxios({
    method: "POST",
    url: `/planner-dashboard/service-package/create`,
    data,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const getPackages = () => {
  return customAxios({
    method: "GET",
    url: `/planner-dashboard/service-package`,
  });
};
export const updateService = (id: number, payload: any) => {
  return customAxios({
    method: "PUT",
    url: `/planner-dashboard/service-package/${id}`,
    data:payload,
  });
};
export const getPackageById = (id: number) => {
  return customAxios({
    method: "GET",
    url: `/planner-dashboard/service-package/${id}`,
  });
};
